import { c as _c } from "react/compiler-runtime";
export const Google = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.0044 4.63966C14.2591 4.63966 15.7799 5.61298 16.6472 6.42628L20.0358 3.1198C17.9545 1.18654 15.2463 0 12.0044 0C7.30849 0 3.25282 2.69313 1.27838 6.61284L5.16053 9.62603C6.13447 6.73284 8.82932 4.63966 12.0044 4.63966Z" fill="#EA4335" />;
    t2 = <path d="M23.5331 12.265C23.5331 11.2784 23.4531 10.5584 23.2796 9.81183H12.0065V14.2648H18.6237C18.4902 15.3714 17.7698 17.038 16.1689 18.1579L19.9577 21.0911C22.2258 18.9978 23.5331 15.9181 23.5331 12.265Z" fill="#4285F4" />;
    t3 = <path d="M5.17636 14.3736C4.92283 13.627 4.7761 12.827 4.7761 12.0004C4.7761 11.1737 4.92284 10.3738 5.16297 9.62721L1.2807 6.61401C0.466999 8.2406 0 10.0671 0 12.0004C0 13.9336 0.466999 15.7602 1.2807 17.3867L5.17636 14.3736Z" fill="#FBBC05" />;
    t4 = <path d="M12.0106 24.0001C15.2524 24.0001 17.9739 22.9335 19.9617 21.0936L16.1729 18.1605C15.159 18.867 13.7982 19.3604 12.0106 19.3604C8.83544 19.3604 6.14059 17.2671 5.18004 14.374L1.29779 17.3871C3.27222 21.3069 7.31449 24.0001 12.0106 24.0001Z" fill="#34A853" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== className) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>{t1}{t2}{t3}{t4}</svg>;
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};